import React from 'react';
import PropTypes from 'prop-types';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var MP4_SOURCE_TYPE = "video/mp4";
var SOURCE_EXTENSION = ".mp4";
var MAX_BROWSER_SPEED = 5;
var PLAYER_SETTINGS = {
  controls: true,
  responsive: true,
  aspectRatio: "16:9",
  playsinline: true
  /* hides iOS native controls in non-fullscreen mode */
  ,
  userActions: {
    hotkeys: true
  },
  controlBar: {
    children: ["playToggle", "volumePanel", "currentTimeDisplay", "timeDivider", "durationDisplay", "progressControl", "customControlSpacer", "pictureInPictureToggle", "fullscreenToggle"]
  }
};
var IDENTIFIER_1X = "1x-high";
var IDENTIFIER_MEDIUM = "1x-medium";
var IDENTIFIER_LOW = "1x-low";
var IDENTIFIER_10X = "10x";
var IDENTIFIER_25X = "25x";
var IDENTIFIER_50X = "50x";
var IDENTIFIER_100X = "100x";
var SPEED_OPTIONS = [{
  label: "100x",
  factor: 100
}, {
  label: "50x",
  factor: 50
}, {
  label: "25x",
  factor: 25
}, {
  label: "10x",
  factor: 10
}, {
  label: "5x",
  factor: 5
}, {
  label: "2x",
  factor: 2
}, {
  label: "1x",
  factor: 1
}, {
  label: "0.5x",
  factor: 0.5
}];
var QUALITY_OPTIONS = [{
  label: "High",
  fileName: IDENTIFIER_1X
}, {
  label: "Medium",
  fileName: IDENTIFIER_MEDIUM
}, {
  label: "Low",
  fileName: IDENTIFIER_LOW
}];

var showQualitySelector = function showQualitySelector(player) {
  var controlBar = player.controlBar;
  var fullscreenToggle = controlBar.getChild("fullscreenToggle").el();
  controlBar.el().insertBefore(controlBar.addChild("QualitySelectorMenu").el(), fullscreenToggle);
};
var hideQualitySelector = function hideQualitySelector(player) {
  var controlBar = player.controlBar;
  controlBar.removeChild("QualitySelectorMenu");
};
var getSrcUrl = function getSrcUrl(source, fileName) {
  if (!source || !fileName) return null;
  var lastIndexOfUrl = source.lastIndexOf("/");
  var url = source.substring(0, lastIndexOfUrl);
  return "".concat(url, "/").concat(fileName).concat(SOURCE_EXTENSION);
};
var getFileNameBySpeed = function getFileNameBySpeed(speedFactor) {
  switch (speedFactor) {
    case 1:
      return IDENTIFIER_1X;

    case 10:
      return IDENTIFIER_10X;

    case 25:
      return IDENTIFIER_25X;

    case 50:
      return IDENTIFIER_50X;

    case 100:
      return IDENTIFIER_100X;

    default:
      return null;
  }
};
var updatePlaybackRate = function updatePlaybackRate(player, playbackRate) {
  player.playbackRate(playbackRate);
  player.defaultPlaybackRate(playbackRate);
};
var showSpeedSelector = function showSpeedSelector(player) {
  var controlBar = player.controlBar;
  var volumePanel = controlBar.getChild("volumePanel").el();
  controlBar.el().insertBefore(controlBar.addChild("SpeedSelectorMenu").el(), volumePanel);
};
var getInitialSource = function getInitialSource(directory) {
  if (!directory) return null;
  if (directory.includes(".mp4")) return directory;
  var fileName = IDENTIFIER_1X;

  if (directory.slice(-1) === "/") {
    return "".concat(directory).concat(fileName).concat(SOURCE_EXTENSION);
  } else {
    return "".concat(directory, "/").concat(fileName).concat(SOURCE_EXTENSION);
  }
};

var MenuItem$1 = videojs.getComponent("MenuItem");

var SpeedSelectorItem = /*#__PURE__*/function (_MenuItem) {
  _inherits(SpeedSelectorItem, _MenuItem);

  var _super = _createSuper(SpeedSelectorItem);

  function SpeedSelectorItem(player, options) {
    var _this;

    _classCallCheck(this, SpeedSelectorItem);

    _this = _super.call(this, player, options);
    _this.selectable = true;

    _this.update();

    return _this;
  }

  _createClass(SpeedSelectorItem, [{
    key: "handleClick",
    value: function handleClick() {
      var selectedSpeed = this.options_.factor;
      var currentSpeed = this.player().displaySpeed;
      var timestamp = this.player().currentTime();
      var nextTimestamp;

      if (selectedSpeed === currentSpeed) {
        return;
      }

      if (selectedSpeed <= MAX_BROWSER_SPEED) {
        if (currentSpeed > MAX_BROWSER_SPEED) {
          var fileName = getFileNameBySpeed(1);
          var source = getSrcUrl(this.player().src(), fileName);
          this.player().src({
            src: source,
            type: MP4_SOURCE_TYPE
          });
          this.player().currentFile = fileName;
          nextTimestamp = timestamp * currentSpeed;
          showQualitySelector(this.player());
        }

        updatePlaybackRate(this.player(), selectedSpeed);
      }

      if (selectedSpeed > MAX_BROWSER_SPEED) {
        var _fileName = getFileNameBySpeed(selectedSpeed);

        var srcUrl = getSrcUrl(this.player().src(), _fileName);
        this.player().src({
          src: srcUrl,
          type: MP4_SOURCE_TYPE
        });
        this.player().currentFile = _fileName;
        updatePlaybackRate(this.player(), 1);
        hideQualitySelector(this.player());

        if (currentSpeed <= MAX_BROWSER_SPEED) {
          nextTimestamp = timestamp / selectedSpeed;
        } else {
          nextTimestamp = timestamp * currentSpeed / selectedSpeed;
        }
      }

      if (nextTimestamp) {
        this.player().currentTime(nextTimestamp);
      }

      this.player().displaySpeed = selectedSpeed;
      this.player().trigger("updateSpeed");
      this.player().play();
      this.options_.controller.triggerItemUpdate();
    }
  }, {
    key: "update",
    value: function update() {
      this.selected(this.player().displaySpeed === this.options_.factor);
    }
  }]);

  return SpeedSelectorItem;
}(MenuItem$1);

var PlaybackRateMenuButton = videojs.getComponent("PlaybackRateMenuButton");

var SpeedSelectorMenu = /*#__PURE__*/function (_PlaybackRateMenuButt) {
  _inherits(SpeedSelectorMenu, _PlaybackRateMenuButt);

  var _super = _createSuper(SpeedSelectorMenu);

  function SpeedSelectorMenu(player, options) {
    var _this;

    _classCallCheck(this, SpeedSelectorMenu);

    _this = _super.call(this, player, options);

    _this.on(player, "updateSpeed", function (e) {
      _this.updateLabel(e);
    });

    _this.addClass("vjs-icon-speed");

    return _this;
  }

  _createClass(SpeedSelectorMenu, [{
    key: "triggerItemUpdate",
    value: function triggerItemUpdate() {
      this.menuItems.forEach(function (item) {
        return item.update();
      });
    }
  }, {
    key: "createItems",
    value: function createItems() {
      this.menuItems = [];

      var _iterator = _createForOfIteratorHelper(SPEED_OPTIONS),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var option = _step.value;
          this.menuItems.push(new SpeedSelectorItem(this.player_, {
            controller: this,
            label: option.label,
            factor: option.factor
          }));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return this.menuItems;
    }
  }, {
    key: "playbackRateSupported",
    value: function playbackRateSupported() {
      return this.player().tech_ && this.player().tech_.featuresPlaybackRate;
    }
  }, {
    key: "updateLabel",
    value: function updateLabel() {
      if (this.playbackRateSupported()) {
        this.labelEl_.textContent = "".concat(this.player().displaySpeed, "x");
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      if (this.buttonPressed_) {
        this.unpressButton();
      } else {
        this.pressButton();
      }
    }
  }]);

  return SpeedSelectorMenu;
}(PlaybackRateMenuButton);

var Plugin$1 = videojs.getPlugin("plugin");

var SpeedSelector = /*#__PURE__*/function (_Plugin) {
  _inherits(SpeedSelector, _Plugin);

  var _super = _createSuper(SpeedSelector);

  function SpeedSelector(player, options) {
    var _this;

    _classCallCheck(this, SpeedSelector);

    _this = _super.call(this, player, options);
    /*
      displaySpeed is the integer value of playback speed shown in the player UI.
      It can also be used to check which playback-speed file is currently playing.
    */

    player.displaySpeed = 1;
    videojs.registerComponent("SpeedSelectorMenu", SpeedSelectorMenu);
    showSpeedSelector(player);
    return _this;
  }

  return SpeedSelector;
}(Plugin$1);

videojs.registerPlugin("speedSelector", SpeedSelector);

var MenuItem = videojs.getComponent("MenuItem");

var QualitySelectorItem = /*#__PURE__*/function (_MenuItem) {
  _inherits(QualitySelectorItem, _MenuItem);

  var _super = _createSuper(QualitySelectorItem);

  function QualitySelectorItem(player, options) {
    var _this;

    _classCallCheck(this, QualitySelectorItem);

    _this = _super.call(this, player, options);
    _this.selectable = true;

    _this.update();

    _this.addClass("vjs-quality-item");

    return _this;
  }

  _createClass(QualitySelectorItem, [{
    key: "handleClick",
    value: function handleClick() {
      var fileName = this.options_.fileName;
      var srcUrl = getSrcUrl(this.player().src(), fileName);
      var timestamp = this.player().currentTime();

      if (!srcUrl || this.player().currentFile === fileName) {
        return;
      }

      this.player().src({
        src: srcUrl,
        type: MP4_SOURCE_TYPE
      });
      this.player().currentFile = fileName;
      this.player().currentTime(timestamp);
      this.player().play();
      this.options_.controller.triggerItemUpdate();
    }
  }, {
    key: "update",
    value: function update() {
      this.selected(this.player().currentFile === this.options_.fileName);
    }
  }]);

  return QualitySelectorItem;
}(MenuItem);

var MenuButton = videojs.getComponent("MenuButton");

var QualitySelectorMenu = /*#__PURE__*/function (_MenuButton) {
  _inherits(QualitySelectorMenu, _MenuButton);

  var _super = _createSuper(QualitySelectorMenu);

  function QualitySelectorMenu(player) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, QualitySelectorMenu);

    _this = _super.call(this, player, options);

    _this.on(player, "updateSpeed", function () {
      _this.triggerItemUpdate();
    });

    return _this;
  }

  _createClass(QualitySelectorMenu, [{
    key: "buildCSSClass",
    value: function buildCSSClass() {
      return "".concat(MenuButton.prototype.buildCSSClass.call(this), " vjs-icon-cog vjs-quality-selector");
    }
  }, {
    key: "triggerItemUpdate",
    value: function triggerItemUpdate() {
      this.menuItems.forEach(function (item) {
        return item.update();
      });
    }
  }, {
    key: "createItems",
    value: function createItems() {
      this.menuItems = [];

      var _iterator = _createForOfIteratorHelper(QUALITY_OPTIONS),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var option = _step.value;
          this.menuItems.push(new QualitySelectorItem(this.player_, {
            controller: this,
            label: option.label,
            fileName: option.fileName
          }));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return this.menuItems;
    }
  }]);

  return QualitySelectorMenu;
}(MenuButton);

var Plugin = videojs.getPlugin("plugin");

var QualitySelector = /*#__PURE__*/function (_Plugin) {
  _inherits(QualitySelector, _Plugin);

  var _super = _createSuper(QualitySelector);

  function QualitySelector(player, options) {
    var _this;

    _classCallCheck(this, QualitySelector);

    _this = _super.call(this, player, options);
    /*
      currentFile is the filename string of the mp4 source which is active.
      It is used to check which file is playing at an instance.
    */

    player.currentFile = IDENTIFIER_1X;
    videojs.registerComponent("QualitySelectorMenu", QualitySelectorMenu);
    showQualitySelector(player);
    return _this;
  }

  return QualitySelector;
}(Plugin);

videojs.registerPlugin("qualitySelector", QualitySelector);

var VideoJS = function VideoJS(props) {
  var videoRef = React.useRef(null);
  var playerRef = React.useRef(null);
  var options = props.options,
      onReady = props.onReady;
  React.useEffect(function () {
    if (!playerRef.current) {
      var videoElement = videoRef.current;
      if (!videoElement) return;
      var player = playerRef.current = videojs(videoElement, options, function () {
        onReady && onReady(player);
      });
    }
  }, [options, videoRef]); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(function () {
    var player = playerRef.current;
    return function () {
      if (player) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);
  return /*#__PURE__*/React.createElement("div", {
    "data-vjs-player": true
  }, /*#__PURE__*/React.createElement("video", {
    ref: videoRef,
    className: "video-js vjs-default-skin vjs-big-play-centered vjs-show-big-play-button-on-pause"
  }, /*#__PURE__*/React.createElement("p", {
    className: "vjs-no-js"
  }, "Javascript is either disabled or unsupported")));
};
VideoJS.propTypes = {
  options: PropTypes.object,
  onReady: PropTypes.func
};

var GsPlayer = function GsPlayer(props) {
  var playerRef = React.useRef(null);
  var initialSource = getInitialSource(props.source);

  var VideoOptions = _objectSpread2(_objectSpread2(_objectSpread2({}, PLAYER_SETTINGS), props.settings), {}, {
    sources: [{
      src: initialSource,
      type: MP4_SOURCE_TYPE
    }]
  });

  var initializeCustomPlugins = function initializeCustomPlugins(player) {
    playerRef.current = player;
    player.speedSelector();
    player.qualitySelector();
    props.onReady && props.onReady();
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(VideoJS, {
    options: VideoOptions,
    onReady: initializeCustomPlugins
  }));
};

GsPlayer.propTypes = {
  source: PropTypes.string.isRequired,
  settings: PropTypes.object,
  onReady: PropTypes.func
};
GsPlayer.defaultProps = {
  onReady: null
};

export { GsPlayer as default };
